"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHowToPay = void 0;
var vue_1 = require("vue");
var PaymentWidgetMixin_1 = require("./PaymentWidgetMixin");
var PreferencesManager_1 = require("./PreferencesManager");
var Button_1 = require("../components/common/Button");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectHowToPay = vue_1.default.component('select-how-to-pay', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        'Button': Button_1.Button,
    },
    data: function () {
        return {
            cost: 0,
            heat: 0,
            megaCredits: 0,
            steel: 0,
            titanium: 0,
            microbes: 0,
            floaters: 0,
            warning: undefined,
        };
    },
    mixins: [PaymentWidgetMixin_1.PaymentWidgetMixin, TranslateMixin_1.TranslateMixin],
    mounted: function () {
        var app = this;
        vue_1.default.nextTick(function () {
            app.setInitialCost();
            app.$data.megaCredits = app.getMegaCreditsMax();
            app.setDefaultSteelValue();
            app.setDefaultTitaniumValue();
            app.setDefaultHeatValue();
        });
    },
    methods: {
        hasWarning: function () {
            return this.$data.warning !== undefined;
        },
        setInitialCost: function () {
            this.$data.cost = this.playerinput.amount;
        },
        setDefaultSteelValue: function () {
            if (!this.canAffordWithMcOnly() && this.canUseSteel()) {
                var requiredSteelQty = Math.ceil(Math.max(this.$data.cost - this.player.megaCredits, 0) / this.player.steelValue);
                if (requiredSteelQty > this.player.steel) {
                    this.$data.steel = this.player.steel;
                }
                else {
                    var currentSteelValue = requiredSteelQty * this.player.steelValue;
                    while (currentSteelValue <= this.$data.cost - this.player.steelValue && requiredSteelQty < this.player.steel) {
                        requiredSteelQty++;
                        currentSteelValue = requiredSteelQty * this.player.steelValue;
                    }
                    this.$data.steel = requiredSteelQty;
                }
                var discountedCost = this.$data.cost - (this.$data.steel * this.player.steelValue);
                this.$data.megaCredits = Math.max(discountedCost, 0);
            }
            else {
                this.$data.steel = 0;
            }
        },
        setDefaultTitaniumValue: function () {
            if (!this.canAffordWithMcOnly() && this.canUseTitanium()) {
                var requiredTitaniumQty = Math.ceil(Math.max(this.$data.cost - this.player.megaCredits - (this.$data.steel * this.player.steelValue), 0) / this.player.titaniumValue);
                if (requiredTitaniumQty > this.player.titanium) {
                    this.$data.titanium = this.player.titanium;
                }
                else {
                    var currentTitaniumValue = requiredTitaniumQty * this.player.titaniumValue;
                    while (currentTitaniumValue <= this.$data.cost - this.player.titaniumValue && requiredTitaniumQty < this.player.titanium) {
                        requiredTitaniumQty++;
                        currentTitaniumValue = requiredTitaniumQty * this.player.titaniumValue;
                    }
                    this.$data.titanium = requiredTitaniumQty;
                }
                var discountedCost = this.$data.cost - (this.$data.steel * this.player.steelValue) - (this.$data.titanium * this.player.titaniumValue);
                this.$data.megaCredits = Math.max(discountedCost, 0);
            }
            else {
                this.$data.titanium = 0;
            }
        },
        setDefaultHeatValue: function () {
            if (!this.canAffordWithMcOnly() && this.canUseHeat()) {
                this.$data.heat = Math.max(this.$data.cost - this.player.megaCredits - (this.$data.steel * this.player.steelValue) - (this.$data.titanium * this.player.titaniumValue), 0);
            }
            else {
                this.$data.heat = 0;
            }
            var discountedCost = this.$data.cost - (this.$data.steel * this.player.steelValue) - (this.$data.titanium * this.player.titaniumValue) - this.$data.heat;
            this.$data.megaCredits = Math.max(discountedCost, 0);
        },
        canAffordWithMcOnly: function () {
            return this.player.megaCredits >= this.$data.cost;
        },
        canUseHeat: function () {
            return this.playerinput.canUseHeat && this.player.heat > 0;
        },
        canUseSteel: function () {
            return this.playerinput.canUseSteel && this.player.steel > 0;
        },
        canUseTitanium: function () {
            return this.playerinput.canUseTitanium && this.player.titanium > 0;
        },
        saveData: function () {
            var htp = {
                heat: this.$data.heat,
                megaCredits: this.$data.megaCredits,
                steel: this.$data.steel,
                titanium: this.$data.titanium,
                microbes: 0,
                floaters: 0,
            };
            if (htp.megaCredits > this.player.megaCredits) {
                this.$data.warning = 'You don\'t have that many M€';
                return;
            }
            if (htp.heat > this.player.heat) {
                this.$data.warning = 'You don\'t have enough heat';
                return;
            }
            if (htp.titanium > this.player.titanium) {
                this.$data.warning = 'You don\'t have enough titanium';
                return;
            }
            if (htp.steel > this.player.steel) {
                this.$data.warning = 'You don\'t have enough steel';
                return;
            }
            var requiredAmt = this.playerinput.amount || 0;
            var totalSpentAmt = htp.heat + htp.megaCredits + (htp.steel * this.player.steelValue) + (htp.titanium * this.player.titaniumValue) + (htp.microbes * 2) + (htp.floaters * 3);
            if (requiredAmt > 0 && totalSpentAmt < requiredAmt) {
                this.$data.warning = 'Haven\'t spent enough';
                return;
            }
            if (requiredAmt === 0) {
                htp.heat = 0;
                htp.megaCredits = 0;
            }
            if (requiredAmt > 0 && totalSpentAmt > requiredAmt) {
                var diff = totalSpentAmt - requiredAmt;
                if (htp.titanium && diff >= this.player.titaniumValue) {
                    this.$data.warning = 'You cannot overspend titanium';
                    return;
                }
                if (htp.steel && diff >= this.player.steelValue) {
                    this.$data.warning = 'You cannot overspend steel';
                    return;
                }
                if (htp.heat && diff >= 1) {
                    this.$data.warning = 'You cannot overspend heat';
                    return;
                }
                if (htp.megaCredits && diff >= 1) {
                    this.$data.warning = 'You cannot overspend megaCredits';
                    return;
                }
            }
            var showAlert = PreferencesManager_1.PreferencesManager.load('show_alerts') === '1';
            if (requiredAmt > 0 && totalSpentAmt > requiredAmt && showAlert) {
                var diff = totalSpentAmt - requiredAmt;
                if (confirm('Warning: You are overpaying by ' + diff + ' M€')) {
                    this.onsave([[JSON.stringify(htp)]]);
                }
                else {
                    this.$data.warning = 'Please adjust payment amount';
                    return;
                }
            }
            else {
                this.onsave([[JSON.stringify(htp)]]);
            }
        },
    },
    template: "<div class=\"payments_cont\">\n  <section v-trim-whitespace>\n\n    <h3 class=\"payments_title\">{{ $t(playerinput.title) }}</h3>\n\n    <div class=\"payments_type input-group\" v-if=\"playerinput.canUseSteel\">\n      <i class=\"resource_icon resource_icon--steel payments_type_icon\" :title=\"$t('Pay by Steel')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('steel', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"steel\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('steel', 1)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('steel')\" title=\"MAX\" />\n    </div>\n\n    <div class=\"payments_type input-group\" v-if=\"playerinput.canUseTitanium\">\n      <i class=\"resource_icon resource_icon--titanium payments_type_icon\" :title=\"$t('Pay by Titanium')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('titanium', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"titanium\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('titanium', 1)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('titanium')\" title=\"MAX\" />\n    </div>\n\n    <div class=\"payments_type input-group\" v-if=\"playerinput.canUseHeat\">\n      <i class=\"resource_icon resource_icon--heat payments_type_icon\" :title=\"$t('Pay by Heat')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('heat', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"heat\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('heat', 1)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('heat')\" title=\"MAX\" />\n    </div>\n\n    <div class=\"payments_type input-group\">\n      <i class=\"resource_icon resource_icon--megacredits payments_type_icon\" :title=\"$t('Pay by Megacredits')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('megaCredits', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"megaCredits\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('megaCredits', 1)\" />\n    </div>\n\n    <div v-if=\"hasWarning()\" class=\"tm-warning\">\n      <label class=\"label label-error\">{{ $t(warning) }}</label>\n    </div>\n\n    <div v-if=\"showsave === true\" class=\"payments_save\">\n      <Button size=\"big\" :onClick=\"saveData\" :title=\"$t(playerinput.buttonLabel)\" />\n    </div>\n\n  </section>\n</div>",
});
//# sourceMappingURL=SelectHowToPay.js.map